'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import 'bootstrap';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    modal_error_title: 'Atenção!',
    modal_error_activity: 'Preencha pelo menos 1 item de Atividade!',
    modal_error_description: 'Preencha a descrição!',
    modal_error_make_donation: 'Informe se você fez doação!',
    modal_error_item_donation: 'Preencha pelo menos 1 item de doação!',
    modal_error_fields: 'Preencha os campos corretamente',
  },
  es: {
    modal_error_title: '¡Atención!',
    modal_error_activity: '¡Completa al menos 1 elemento de actividad!',
    modal_error_description: '¡Completa la descripción!',
    modal_error_make_donation: '¡Por favor, infórmanos si hiciste una donación!',
    modal_error_item_donation: '¡Por favor complete al menos 1 artículo de donación!',
    modal_error_fields: 'Rellena los campos correctamente',
  },
  en: {
    modal_error_title: 'Warning!',
    modal_error_activity: 'Check at least one activity to proceed.',
    modal_error_description: 'Fill in the description!',
    modal_error_make_donation: 'Please let us know if you made a donation!',
    modal_error_item_donation: 'Please complete at least 1 donation item!',
    modal_error_fields: 'Please fill out all the fields correctly',
  },
};

const reportactivities = {
  init() {
    $('.custom-control-input').on('change', function (e) {
      let type = $("input[name='type']:checked").val();

      if (this.value == 1) {
        $('#' + $(this).attr('data-id')).removeClass('u-display--none');
      } else {
        $('#' + $(this).attr('data-id')).addClass('u-display--none');
        $('#' + $(this).attr('data-id'))
          .find('input:text')
          .val('');
      }
    });

    $('.js-form-activities').on('submit', function (e) {
      e.preventDefault();
      let submitForm = true;
      let count = 0;

      $('input[type="checkbox"]:checked').each(function (index, el) {
        if (el.value.length > 0) {
          count++;
        }
      });

      if (count <= 0) {
        Swal.fire({
          icon: 'error',
          title: tr[lang].modal_error_title,
          text: tr[lang].modal_error_activity,
        });
        submitForm = false;
        return false;
      }

      if (!$('[name="activities_description"]').val()) {
        Swal.fire({
          icon: 'error',
          title: tr[lang].modal_error_title,
          text: tr[lang].modal_error_description,
        });
        submitForm = false;
        return false;
      }

      if ($("input[name='make_donation']").length) {
        if ($("input[name='make_donation']:checked").val() != 0 && $("input[name='make_donation']:checked").val() != 1) {
          Swal.fire({
            icon: 'error',
            title: tr[lang].modal_error_title,
            text: tr[lang].modal_error_make_donation,
          });
          submitForm = false;
          return false;
        }

        count = 0;

        if ($("input[name='make_donation']:checked").val() == 1) {
          $('#donation input').each(function (index, el) {
            if (el.value.length > 0) {
              count++;
            }
          });

          if (count <= 0) {
            Swal.fire({
              icon: 'error',
              title: tr[lang].modal_error_title,
              text: tr[lang].modal_error_item_donation,
            });
            submitForm = false;
            return false;
          }
        }
      }

      $('#report [required]').each(function (index, el) {
        if (el.value.length <= 0) {
          Swal.fire({
            icon: 'error',
            title: tr[lang].modal_error_title,
            text: tr[lang].modal_error_fields,
          });
          submitForm = false;
          return false;
        }
        submitForm = true;
      });

      if (submitForm) {
        e.target.submit();
      }
    });
  },
};

const _this = reportactivities;

export default _this;
